import { c as _c } from "react/compiler-runtime";
import { cn } from 'cn';
import { range } from '@/utils/range';
type MarqueeProps = {
  children: React.ReactNode;
  gap?: string;
  duration?: number;
  direction?: 'left' | 'up';
  pauseOnHover?: boolean;
  fade?: boolean;
  reverse?: boolean;
  className?: string;
};
export function Marquee(props) {
  const $ = _c(16);
  const {
    children,
    gap: t0,
    duration: t1,
    direction: t2,
    pauseOnHover: t3,
    fade: t4,
    reverse: t5,
    className
  } = props;
  const gap = t0 === undefined ? "1rem" : t0;
  const duration = t1 === undefined ? 30 : t1;
  const direction = t2 === undefined ? "left" : t2;
  const pauseOnHover = t3 === undefined ? true : t3;
  const fade = t4 === undefined ? true : t4;
  const reverse = t5 === undefined ? false : t5;
  const maskDirection = direction === "left" ? "to right" : "to bottom";
  const mask = fade ? `linear-gradient(${maskDirection}, transparent 0%, rgba(0, 0, 0, 1.0) 10%, rgba(0, 0, 0, 1.0) 90%, transparent 100%)` : undefined;
  let t6;
  if ($[0] !== className) {
    t6 = cn("group flex overflow-hidden data-[direction=left]:flex-row data-[direction=up]:flex-col", className);
    $[0] = className;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  let t7;
  if ($[2] !== gap || $[3] !== mask) {
    t7 = {
      maskImage: mask,
      WebkitMaskImage: mask,
      gap
    };
    $[2] = gap;
    $[3] = mask;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== children || $[6] !== duration || $[7] !== gap) {
    t8 = range(2).map(number => <div key={number} style={{
      "--marquee-gap": gap,
      "--marquee-duration": `${duration}s`
    }} className="flex shrink-0 justify-around gap-(--marquee-gap) group-data-[direction=left]:animate-marquee-x group-data-[direction=left]:flex-row group-data-[direction=up]:animate-marquee-y group-data-[direction=up]:flex-col group-data-[pause-on-hover=true]:group-hover:paused group-data-[reverse=true]:direction-reverse">{children}</div>);
    $[5] = children;
    $[6] = duration;
    $[7] = gap;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== direction || $[10] !== pauseOnHover || $[11] !== reverse || $[12] !== t6 || $[13] !== t7 || $[14] !== t8) {
    t9 = <div data-slot="marquee" data-direction={direction} data-pause-on-hover={pauseOnHover} data-reverse={reverse} className={t6} style={t7}>{t8}</div>;
    $[9] = direction;
    $[10] = pauseOnHover;
    $[11] = reverse;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
}